export default (rows, cols) => {
  const wells = [];
  for (let i = 0; i < rows; i += 1) {
    wells.push([]);
    for (let j = 0; j < cols; j += 1) {
      wells[i].push([]);
    }
  }
  return wells;
};



// WEBPACK FOOTER //
// ./src/utils/generateEmptyBoard.js